/** The outbound delivery record (Features 50 and 53). Retry applies to failed rows only. */
import { apiGet, apiPost } from '../client.js';
import type { DeliveryEvent, DeliveryStatus, WebhookDelivery } from '../types.js';

export interface ListWebhookDeliveriesFilters {
  organization_id?: string;
  federated_partner_id?: string;
  status?: DeliveryStatus;
  task_id?: string;
  event?: DeliveryEvent;
  limit?: number;
  offset?: number;
}

export function listWebhookDeliveries(
  filters: ListWebhookDeliveriesFilters = {},
): Promise<WebhookDelivery[]> {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== undefined),
  );
  return apiGet<WebhookDelivery[]>(
    '/api/v1/admin/webhook-deliveries',
    Object.keys(params).length > 0 ? params : undefined,
  );
}

/** One task's events in the order they were announced, for the task screen. */
export function listTaskWebhookDeliveries(taskId: string): Promise<WebhookDelivery[]> {
  return apiGet<WebhookDelivery[]>(`/api/v1/admin/tasks/${taskId}/webhook-deliveries`);
}

export function retryWebhookDelivery(deliveryId: string): Promise<WebhookDelivery> {
  return apiPost<WebhookDelivery>(
    `/api/v1/admin/webhook-deliveries/${deliveryId}/retry`,
    {},
  );
}
